export default __webpack_public_path__ + "static/media/Scholar's Tunic of the Celestial Hilt.c6b4ae46.jpg";